import { User } from "@/types/types";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";
import { isYearlySubscription } from "@/utils/subscriptionLevels/isYearlySubscription";

const differentiateWhenSame = (
  currentStripeSubscriptionId: NonNullable<User["stripeSubscriptionId"]>,
  newStripeSubscriptionId: NonNullable<User["stripeSubscriptionId"]>
) => {
  const isYearlyCurrent = isYearlySubscription(currentStripeSubscriptionId);
  const isYearlyNew = isYearlySubscription(newStripeSubscriptionId);

  if (isYearlyCurrent && !isYearlyNew) {
    return "goMonthly";
  } else if (!isYearlyCurrent && isYearlyNew) {
    return "goYearly";
  } else {
    return "same";
  }
};

export const getChangeSubscriptionPlanStatus = (
  currentStripeSubscriptionId: NonNullable<User["stripeSubscriptionId"]>,
  newStripeSubscriptionId: NonNullable<User["stripeSubscriptionId"]>
): "upgrade" | "downgrade" | "same" | "goYearly" | "goMonthly" | null => {
  const currentPlan = getSubscriptionPlan(currentStripeSubscriptionId);
  const newPlan = getSubscriptionPlan(newStripeSubscriptionId);

  // Should never happen
  if (currentPlan === "free" || newPlan === "free") {
    return null;
  }

  if (currentPlan === "first") {
    if (newPlan === "first") {
      return differentiateWhenSame(
        currentStripeSubscriptionId,
        newStripeSubscriptionId
      );
    } else {
      return "upgrade";
    }
  } else if (currentPlan === "second") {
    if (newPlan === "second") {
      return differentiateWhenSame(
        currentStripeSubscriptionId,
        newStripeSubscriptionId
      );
    } else if (newPlan === "first") {
      return "downgrade";
    } else if (newPlan === "third") {
      return "upgrade";
    }
  } else if (currentPlan === "third") {
    if (newPlan === "third") {
      return differentiateWhenSame(
        currentStripeSubscriptionId,
        newStripeSubscriptionId
      );
    } else {
      return "downgrade";
    }
  }

  // Should never happen
  return null;
};
